import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { RegiaoLocalizacoesFilter, RegiaoLocalizacoesResponse } from '../adapters';
import { RegiaoLocalizacoesCacheService } from './regiao-localizacoes-cache.service';
import { RegioesLocalizacoesHttpService } from './regiao-localizacoes-http.service';

@Injectable({
  providedIn: 'root'
})
export class RegiaoLocalizacoesGatewayService {
    constructor(private regiaoLocalizacoesCacheService: RegiaoLocalizacoesCacheService,
                private regioesLocalizacoesHttpService: RegioesLocalizacoesHttpService) {}

    getLocalizacoes(filter: RegiaoLocalizacoesFilter): Promise<RegiaoLocalizacoesResponse> {
        return new Promise<RegiaoLocalizacoesResponse>((resolve) => {
            // Tentando obter do cache
            const localizacoesCache = this.regiaoLocalizacoesCacheService.getLocalizacoes();
            // Se encontrar no cache, então retorna do cache
            if (localizacoesCache) {
                resolve(localizacoesCache);
                return;
            }

            // Se não, faz o request HTTP e armazena no cache
            this.regioesLocalizacoesHttpService.getLocalizacoes(filter)
                .pipe(take(1))
                .subscribe(
                    localizacoes => {
                        // Armazenando as localizações no cache
                        this.regiaoLocalizacoesCacheService.setLocalizacoes(localizacoes);
                        // Retornando as localização
                        resolve(localizacoes);
                    }
                );
        });
    }
}
